import { PageLayout } from '../../../core/types/Typesetter';
import { extractPageHashes } from '../pagination';
import { WasmLogger } from '../../../../../utils/loggers/WasmLogger';

/**
 * PageHashStorer - Utility for storing page hashes in the page hash cache
 *
 * Handles the extraction and storage of page hashes from PageLayout objects.
 * Used during pagination to build the hash cache for early termination in
 * incremental pagination operations.
 */
export class PageHashStorer {
  /**
   * Store page hashes from PageLayout array into the page hash map
   *
   * This method extracts page hashes from the provided pages and stores them
   * in the page hash cache for use in early termination during incremental
   * pagination. Each page's hash is stored with its page index as the key.
   *
   * @param pages - Array of PageLayout objects to extract hashes from
   * @param pageHashes - Map to store page indices to page hashes (will be updated)
   */
  static storePageHashes(
    pages: PageLayout[],
    pageHashes: Map<number, string>
  ): void {
    // Extract page hashes using utility function
    const newHashes = extractPageHashes(pages);

    // Merge into existing page hashes
    for (const [pageIndex, pageHash] of newHashes.entries()) {
      pageHashes.set(pageIndex, pageHash);
    }

    WasmLogger.pagination.hashesStored(pages.length, pageHashes.size);
  }
}
